import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Briefcase, MapPin, Loader2, ArrowRight, Building2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export const VerifiedOpportunities = ({ token }) => {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/api/verified-talent/opportunities`, { headers: { Authorization: `Bearer ${token}` } });
        setItems((res.data.opportunities || []).filter((o) => o.title));
      } catch { /* silent */ } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  if (loading) {
    return <div className="mt-8 flex items-center justify-center text-zinc-500 gap-2 text-sm"><Loader2 className="animate-spin" size={15} /> Matching you to opportunities…</div>;
  }
  if (!items.length) return null;

  return (
    <div className="mt-8 max-w-3xl mx-auto text-left" data-testid="matched-opportunities">
      <div className="flex items-center gap-2 mb-3">
        <Briefcase size={14} className="text-emerald-300" />
        <h3 className="text-[11px] font-bold tracking-[0.2em] uppercase text-zinc-300">Matched opportunities</h3>
      </div>
      <div className="space-y-3">
        {items.map((o) => (
          <div key={o.id} className="rounded-xl border border-white/10 bg-white/[0.02] p-4 flex items-center justify-between gap-4" data-testid="opportunity-card">
            <div className="min-w-0">
              <p className="font-semibold text-white truncate">{o.title}</p>
              <p className="text-xs text-zinc-400 flex items-center gap-2 mt-0.5">
                {o.company && <span className="inline-flex items-center gap-1"><Building2 size={12} /> {o.company}</span>}
                {o.location && <span className="inline-flex items-center gap-1"><MapPin size={12} /> {o.location}</span>}
                {o.work_mode && <span className="uppercase tracking-wide text-[10px] text-zinc-500">{o.work_mode}</span>}
              </p>
              {(o.matched_skills || []).length > 0 && (
                <div className="flex flex-wrap gap-1.5 mt-2">
                  {o.matched_skills.slice(0, 5).map((s, i) => (
                    <span key={i} className="text-[10px] px-2 py-0.5 rounded-full bg-emerald-500/10 text-emerald-300 border border-emerald-400/20 capitalize">{s}</span>
                  ))}
                </div>
              )}
            </div>
            <div className="flex flex-col items-end gap-2 flex-shrink-0">
              <div className="text-right">
                <p className="text-lg font-bold text-emerald-400 tabular-nums">{o.match_percentage}%</p>
                <p className="text-[9px] uppercase tracking-widest text-zinc-500">match</p>
              </div>
              <a
                href={o.apply_link || '/codearena/job-board'}
                target={o.apply_link ? '_blank' : '_self'}
                rel="noreferrer"
                className="inline-flex items-center gap-1 text-xs font-semibold text-purple-300 hover:text-purple-200"
              >
                View <ArrowRight size={12} />
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VerifiedOpportunities;
